import { render, staticRenderFns } from "./RegistrationOfferDecreasePage.vue?vue&type=template&id=d4333596&scoped=true"
import script from "./RegistrationOfferDecreasePage.vue?vue&type=script&lang=ts"
export * from "./RegistrationOfferDecreasePage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationOfferDecreasePage.vue?vue&type=style&index=0&id=d4333596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4333596",
  null
  
)

export default component.exports